import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native'
import React, { useState } from 'react'
import Card from '../../../components/shared/card/Card'
import { AntDesign } from '@expo/vector-icons'
import { useLabourStore } from '../../../stores/labour'
import { useshiftstore } from '../../../stores/shift'
import { colorPalette, fontPalette, globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import { useHomeStore } from '../../../stores/home'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import { response } from '../../../types/shiftTypes'
import { useInitializeStore } from '../../../stores/initialize'
import Icon from 'react-native-vector-icons/FontAwesome'

import moment from 'moment'
import { convertTo12HourTime } from '../../../utils'
import Toast from 'react-native-toast-message'
import { useTranslation } from 'react-i18next'

const SwapShift = ({ navigation, route }) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: Id,
    refresh,
    time_In,
    time_Out,
    dayOfMonth,
    dayName,
    shiftiD
  } = params
  const [showHide, setShowHide] = React.useState(false)
  const shiftStore = useshiftstore()
  const intializeStore = useInitializeStore()

  const [secondShiftId, setSecondShiftId] = useState('')
  const [disabled, setDisabled] = useState(true)
  const [shiftData, setShiftData] = useState(null)
  const { t } = useTranslation()

  const body = {
    essUserKey: intializeStore.initializeData.userkey,
    shifId: shiftiD,
    secondShiftId: parseInt(secondShiftId)
  }
  const getDetails = async (id) => {
    const response = await shiftStore.fetchswapshiftDetails(id)

    setShiftData(response)
    setDisabled(!response?.data?.success)
  }


  const handlesubmit = async () => {
    const data: response = await shiftStore.swapshift(body)
    if (data?.success == true) {

      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: t(data?.message),
        visibilityTime: 5000,
        autoHide: true,
        topOffset: 60
      })
      navigation.navigate('LabourSavourSchedule')
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: t(data?.message),
        visibilityTime: 5000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>

        <View style={[globalStyles.vCenterItems, , { marginTop: -30 }]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter,
              { marginBottom: 5 }
            ]}
          >
            {t('Swap Shift')}
          </Text>
          <TouchableOpacity
            style={[styles.custom]}
            onPress={() => navigation.navigate('LabourSavourSchedule')}
          >
            <Text style={{ fontSize: 20, color: 'white' ,fontFamily:fontPalette.primaryBold}}>
              {t('cancel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: -44,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          <View style={{ flexDirection: 'row' }}>
            <TouchableOpacity
              onPress={() => {
                setShowHide(!showHide)
              }}
            >
              <View
                style={{
                  justifyContent: 'center',
                  padding: 10,
                  backgroundColor: '#0B495C',
                  width: 70,
                  height: 70,
                  borderRadius: 5
                }}
              >
                <Text
                  style={{
                    fontSize: 25,
                    textAlign: 'center',
                    color: 'white',
                    fontFamily:fontPalette.primaryRegular
                  }}
                >
                  {dayOfMonth}
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    textAlign: 'center',
                    color: 'white',
                    fontFamily:fontPalette.primaryRegular
                  }}
                >
                  {dayName}
                </Text>
              </View>
            </TouchableOpacity>
            <View style={{ marginLeft: 10 }}>
              <Text
                style={{
                  fontWeight: 'bold',
                  marginBottom: 4,
                  fontFamily:fontPalette.primaryRegular
                }}
              >
                {time_In} - {time_Out}
              </Text>
              <Text> {t('Shift Id')} : {shiftiD}</Text>
            </View>
          </View>
          <View
            style={{ flexDirection: 'row', justifyContent: 'space-between' }}
          >
            {/* <Text>Ess userkey : {labourStore.labourData?.essUserKey}</Text> */}
          </View>
          <CardSeparator />
          <View>
            <Text
              style={[
                globalStyles.inputLabel,
                globalStyles.inputLabelLarge,
                globalStyles.inputLabelPrimary,
                { marginTop: 10 }
              ]}
            >
              {t('Swap Shift Id')}
            </Text>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <TextInput
                style={[
                  globalStyles.input,
                  globalStyles.inputLight,
                  globalStyles.inputReadOnly,
                  { width: '85%' }
                ]}
                value={secondShiftId}
                onChangeText={(text) => setSecondShiftId(text)}
                keyboardType="numeric"
              />

              <TouchableOpacity
                style={{
                  padding: 7,
                  height: 40,
                  width: 35,
                  alignItems: 'center',
                  backgroundColor: colorPalette.skyBlue,
                  marginLeft: 10,
                  borderWidth: 0,
                  borderRadius: 10,
                }}
                onPress={() => getDetails(secondShiftId)}
              >
                <Icon
                  name="search"
                  size={20}
                  color="white"
                  style={{ right: 0 }}
                />
              </TouchableOpacity>
            </View>
          </View>

          {shiftData?.data?.success && (
            <View
              style={{
                backgroundColor: '#f1f1f1',
                padding: 5,
                marginTop: 10,
                borderRadius: 10
              }}
            >
              <Text style={{ fontWeight: 'bold', fontFamily:fontPalette.primaryRegular }}>{t('Shift Details')} </Text>
              <View style={{ flexDirection: 'row', paddingVertical: 5 }}>
                <Text style={{ fontFamily:fontPalette.primaryRegular}}>{t('name')} : {shiftData?.data?.firstName}</Text>
              </View>
              <Text
                style={{
                  marginBottom: 4,
                  fontFamily:fontPalette.primaryRegular
                }}
              >
                {moment(shiftData?.data?.date).format('MM/DD/YYYY')}{' '}
                {convertTo12HourTime(shiftData?.data?.timeIn)} -{' '}
                {convertTo12HourTime(shiftData?.data?.timeOut)}{' '}
                {`(Hrs. ${moment(
                  shiftData?.data?.scheeduledHours,
                  'HH:mm'
                ).format('HH:mm')})`}
              </Text>
              <Text style={{ fontFamily:fontPalette.primaryRegular}}>{t(shiftData?.data?.message)}</Text>
            </View>
          )}
          {shiftData && !shiftData?.data?.success && (
            <View
              style={{
                backgroundColor: 'rgb(247 190 89)',
                padding: 5,
                marginTop: 10,
                borderRadius: 10, flexDirection: 'row'
              }}
            >
              <AntDesign name="exclamationcircleo" size={20} color='black' style={{ padding: 5 }} />
              <Text style={{ padding: 5, fontFamily:fontPalette.primaryRegular }}>{t(shiftData?.data?.message)}</Text>
            </View>
          )}
          {/* {shiftStore?.error ? <Text>{shiftStore?.error}</Text> : <></>} */}
        </Card>
        <TouchableOpacity
          disabled={disabled}
          style={[
            styles.custom2,
            {
              backgroundColor: disabled ? colorPalette.gray : colorPalette.green
            }
          ]}
          onPress={handlesubmit}
        >
          <View>
            <Text style={{ fontSize: 20,  color: 'white', fontFamily:fontPalette.primaryBold }}>
              {t('Submit Swap Shift')}
            </Text>
          </View>
        </TouchableOpacity>

      </View>
    </>
  )
}

export default SwapShift

const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    height: 40,
    width: '90%',
    alignItems: 'center',
    backgroundColor: colorPalette.skyBlue,
    color: 'black',
    borderWidth: 0,
    borderRadius: 11,
    marginTop: 5
  },
  custom2: {
    justifyContent: 'center',
    flexDirection: 'row',
    height: 40,
    width: '95%',
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 0,
    borderRadius: 10
  },
})
